/**
 * @generated SignedSource<<766449fb01bfa96a943406f8c24c21db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AddScreenScanQRMutation$variables = {
  deviceCode: string;
  storecastId?: string | null;
};
export type AddScreenScanQRMutation$data = {
  readonly storecastInstall: {
    readonly activeSession: {
      readonly endAt: string;
      readonly id: string;
      readonly latencyMs: number | null;
    } | null;
    readonly dashboard: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly id: string;
    readonly name: string;
  } | null;
};
export type AddScreenScanQRMutation = {
  response: AddScreenScanQRMutation$data;
  variables: AddScreenScanQRMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "deviceCode",
        "variableName": "deviceCode"
      },
      {
        "kind": "Variable",
        "name": "storecastId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "StorecastScreen",
    "kind": "LinkedField",
    "name": "storecastInstall",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastSession",
        "kind": "LinkedField",
        "name": "activeSession",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "latencyMs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddScreenScanQRMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddScreenScanQRMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "3f818043863fe3fb1dddc9f28f72d204",
    "id": null,
    "metadata": {},
    "name": "AddScreenScanQRMutation",
    "operationKind": "mutation",
    "text": "mutation AddScreenScanQRMutation(\n  $deviceCode: String!\n  $storecastId: ID\n) {\n  storecastInstall(deviceCode: $deviceCode, storecastId: $storecastId) {\n    id\n    name\n    dashboard {\n      id\n      name\n    }\n    activeSession {\n      id\n      latencyMs\n      endAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "484bca26dec958f27e38131a07d49ff5";

export default node;
